import styled from 'styled-components';
import { vw } from 'components/common/Common';
import JetTypeSection from './JetTypeSection';
import Introduce from './Introduce';
import Question from './Question';
import Header from './Header';
import { H1, P } from '../Jet.style';

const HeaderContent = {
  url: '/charterQuote',
  urlText: 'Book your Private Jet',
  imgUrl: '/imgs/webp/jet/bottom.webp',
  titleContent: <H1>Book a Flight Today</H1>,
  descContent: (
    <P $color="#fff" $align="right">
      Airacer can help you fly in comfort and style on a private jet. Aircraft to airport, we
      <br />
      guarantee your experience will be unlike any other
    </P>
  ),
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: ${vw(50)} 0 0;
  display: flex;
  flex-direction: column;
  gap: ${vw(100)};
`;

const Content = () => {
  const { url, urlText, imgUrl, titleContent, descContent } = HeaderContent;
  return (
    <Container>
      <Introduce />
      <JetTypeSection />
      <Question />
      <Header
        url={url}
        urlText={urlText}
        imgUrl={imgUrl}
        titleContent={titleContent}
        descContent={descContent}
        height={'600'}
        isRight={true}
      />
    </Container>
  );
};

export default Content;
